var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [
        _vm._v(
          _vm._s(_vm.$translate("Ceres::Template.itemManufacturerDetailsTitle"))
        )
      ]),
      _vm._v(" "),
      _vm.manufacturer && _vm.isManufacturerTabShown
        ? [
            _vm.concatenatedNames
              ? _c("div", { staticClass: "mb-2" }, [
                  _c("b", [_vm._v(_vm._s(_vm.concatenatedNames))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.manufacturer.name && _vm.visibleFields.includes("name")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [_vm._v(_vm._s(_vm.manufacturer.name))])
                ])
              : _vm.manufacturer.externalName &&
                _vm.visibleFields.includes("name")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [_vm._v(_vm._s(_vm.manufacturer.externalName))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("legalName")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [_vm._v(_vm._s(_vm.manufacturer.legalName))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "p-0" }, [
              _vm.visibleFields.includes("street")
                ? _c("span", [_vm._v(_vm._s(_vm.manufacturer.street))])
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleFields.includes("houseNr")
                ? _c("span", [_vm._v(_vm._s(_vm.manufacturer.houseNo))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-0" }, [
              _vm.visibleFields.includes("zipcode")
                ? _c("span", [_vm._v(_vm._s(_vm.manufacturer.postcode))])
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleFields.includes("city")
                ? _c("span", [_vm._v(_vm._s(_vm.manufacturer.town))])
                : _vm._e(),
              _vm._v(" "),
              _vm.manufacturer.countryObject &&
              _vm.visibleFields.includes("country")
                ? _c("span", [
                    _vm._v(_vm._s(_vm.manufacturer.countryObject.name))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.visibleFields.includes("mail")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [_vm._v(_vm._s(_vm.manufacturer.email))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("homepage")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [_vm._v(_vm._s(_vm.manufacturer.url))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("phone")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [_vm._v(_vm._s(_vm.manufacturer.phoneNumber))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("fax")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [_vm._v(_vm._s(_vm.manufacturer.faxNumber))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("contactForm")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [_vm._v(_vm._s(_vm.manufacturer.contactUrl))])
                ])
              : _vm._e()
          ]
        : [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$translate(
                    "Ceres::Template.itemManufacturerNoInformation"
                  )
                ) +
                "\n  "
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }